import { render, staticRenderFns } from "./TeamsCalendar.vue?vue&type=template&id=a855e084&"
import script from "./TeamsCalendar.vue?vue&type=script&lang=js&"
export * from "./TeamsCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports